<i18n lang="yaml" locale="en">
email: E-Mail
login: Login
oauth: Login with {title}
password: Password
</i18n>

<i18n lang="yaml" locale="de">
email: E-Mail
login: Anmelden
oauth: Mit {title} anmelden
password: Passwort
</i18n>

<template>
  <section
    v-if="!pending"
    class="login"
  >
    <form @submit.prevent="submit(email, password)">
      <div class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          version="1.1"
        >
          <path
            d="M24,20c0,1.2-0.4,2.2-1.2,3S20.8,24,19.4,24H4.6c-1.4,0-2.5-0.4-3.3-1.1S0,21.2,0,20c0-0.6,0-1.1,0.1-1.6s0.1-1.1,0.2-1.7 s0.3-1.2,0.5-1.7s0.4-1,0.7-1.5s0.7-0.9,1.1-1.3s0.9-0.6,1.5-0.8S5.2,11,5.9,11c0.1,0,0.3,0.1,0.7,0.3s0.8,0.5,1.3,0.8 c0.5,0.3,1.1,0.5,1.8,0.8c0.8,0.2,1.5,0.3,2.3,0.3s1.5-0.1,2.3-0.3c0.8-0.2,1.4-0.5,1.8-0.8c0.5-0.3,0.9-0.5,1.3-0.8S18,11,18.1,11 c0.7,0,1.3,0.1,1.9,0.3c0.6,0.2,1.1,0.5,1.5,0.8s0.8,0.8,1.1,1.3s0.6,1,0.7,1.5s0.3,1.1,0.5,1.7s0.2,1.2,0.2,1.7 C24,18.9,24,19.4,24,20z M18.5,6c0,1.7-0.6,3.1-1.9,4.2C15.3,11.4,13.8,12,12,12s-3.3-0.6-4.6-1.8S5.5,7.7,5.5,6s0.6-3.1,1.9-4.2 S10.2,0,12,0s3.3,0.6,4.6,1.8C17.9,2.9,18.5,4.3,18.5,6z"
          />
        </svg>
      </div>
      <input
        type="text"
        name="email"
        v-model="email"
        :placeholder="$t('email')"
      >
      <input
        type="password"
        name="password"
        v-model="password"
        :placeholder="$t('password')"
      >
      <button type="submit">
        {{ $t('login') }}
      </button>
      <div
        v-if="error"
        class="error"
      >
        {{ error }}
      </div>
      <div
        v-for="({ title }, strategy) in strategies"
        :key="strategy"
      >
        <p>oder</p>
        <a :href="'/oauth/' + strategy">{{ $t('oauth', { title }) }}</a>
      </div>
    </form>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      pending: false,
      email: '',
      password: '',
      error: '',
      strategies: {}
    }
  },
  methods: {
    async submit (email, password) {
      this.pending = true
      try {
        const resp = await axios.post('/authentication', {
          strategy: 'user',
          email: email.toLowerCase(),
          password
        })
        await this.$root.$store.dispatch('setUser', { user: resp.data.user })
      } catch {
        this.$root.$store.dispatch('setUser', null)
      } finally {
        this.pending = false
      }
    },
    async auth (accessToken) {
      this.pending = true
      try {
        const resp = await axios.post('/authentication', {
          strategy: 'jwt',
          accessToken
        })
        await this.$root.$store.dispatch('setUser', { user: resp.data.user || resp.data.device })
      } catch {
        this.$root.$store.dispatch('setUser', null)
      } finally {
        this.pending = false
      }
    },
    hashChange () {
      const hash = window.location.hash.match(new RegExp('(.*)access_token=(.+)$'))
      if (hash) {
        this.auth(hash[2])
        this.$router.replace('/')
      }
    }
  },
  async created () {
    const resp = await axios.get('/authentication')
    this.strategies = resp.data
  },
  mounted () {
    this.hashChange()
    const cookie = document.cookie.match(new RegExp('(^| )touchwert-jwt=([^;]+)'))
    if (cookie) {
      this.auth(cookie[2])
    }
    window.addEventListener('hashchange', this.hashChange, false)
  },
  beforeDestroy () {
    window.removeEventListener('hashchange', this.hashChange, false)
  }
}
</script>

<style lang="scss" scoped>
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.3);
  }
  70% {
      -webkit-box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
@keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
              box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
              box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

section.login {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: #1d3557 url('/img/background.jpg') 0 0 no-repeat;
  background-size: cover;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

form {
  width: 320px;
  padding: 70px 40px 40px 40px;
  background-color: #fff;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 64px rgba(0, 0, 0, 0.75);
          box-shadow: 0 0 64px rgba(0, 0, 0, 0.75);
  position: relative;
}

.icon {
  position: absolute;
  width: 100px;
  height: 100px;
  background-color: #fff;
  left: 50%;
  top: -42px;
  -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
          transform: translateX(-50%);
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-shadow: 0 0 0 rgba(255, 255, 255, 0.3);
          box-shadow: 0 0 0 rgba(255, 255, 255, 0.3);
  -webkit-animation: pulse 2s infinite;
          animation: pulse 2s infinite;
}

.icon > svg {
  width: 56px;
  height: 56px;
  fill: #a8dadc;
  position: relative;
}

input {
  width: 100%;
  margin-bottom: 1.5rem;
  background: #fff;
  border: solid #999;
  border-width: 0 0 1px 0;
  padding: 8px 0;
  font-size: 16px;
  letter-spacing: 0.5pt;
  font-family: 'Ubuntu', sans-serif;
}

input:-webkit-autofill {
  background-color: #fff;
  -webkit-box-shadow: inset 0 0 0px 9999px #fff;
          box-shadow: inset 0 0 0px 9999px #fff;
}

input:focus {
  outline: none;
  border-color: #000;
}

button, a {
  width: 100%;
  background: #009fe3;
  border: none;
  color: #fff;
  padding: 15px;
  text-transform: uppercase;
  letter-spacing: 0.5pt;
  cursor: pointer;
  font-size: 14px;
  margin-top: 1rem;
  font-family: 'Ubuntu', sans-serif;
  display: block;
  text-align: center;
}

button:hover, a:hover {
  background-color: #1d3557;
}

p {
  text-align: center;
  color: black;
}

.error {
  color: red;
}
</style>
